<template>
  <div class="main_tc" @click="closeweb" v-if="isWebOpen">
    <!--音效-->
    <audio preload id="audio">
      <source src="../../assets/turntable/sound.mp3" type="audio/mpeg" />
      Your browser does not support the audio tag.
    </audio>

    <div id="turntable" @click.stop>
      <!--转盘区域-->
      <div class="table relativeItem" v-show="show === 1">
        <div class="flex-box t-top title">
          <a class="ph-button" @click="show = 4">
            <img src="../../assets/turntable/tb.png" />
          </a>
          <div class="marquee relativeItem">
            <div class="quee-shell">
              <div class="flex-box mar-items" :style="{ animation: animation }">
                <p class="marquee-item" v-for="(n, index) in get_news_list" :key="index">
                  恭喜
                  <span class="name">{{ n.nickname }}</span> 在大转盘抽中
                  <span class="gift">{{ n.giftname }}</span>
                </p>
              </div>
            </div>
          </div>

          <span class="top-button" @click="show = 2">抽奖规则</span>
          <span class="top-button" @click="show = 3">中奖记录</span>
        </div>

        <!--双色背景-->
        <img src="../../assets/turntable/tb(2).png" class="out-light" />

        <!--转盘中心-->
        <div class="tableShell relativeItem" :class="{ tableShell180: num === 2 }">
          <!--普通转盘-->
          <div class="table-center com-table relativeItem">
            <img class="light" src="../../assets/turntable/tb(12).png" v-show="bk" />
            <img class="light" src="../../assets/turntable/tb(13).png" v-show="!bk" />

            <div class="f absoluteItem">
              <div
                class="item absoluteItem"
                :class="{ active: bingo === index }"
                v-for="(n, index) in list"
                :key="index"
              >
                <img
                  src="../../assets/turntable/tb(11).png"
                  class="centerImg ac-img"
                  :class="{ hide_ac_img: bingo != index }"
                />
                <div class="big-shell absoluteItem centerImg">
                  <div class="img-shell relativeItem">
                    <img class="imgBlcok absoluteItem centerImg" :src="n.giftimage" />
                  </div>
                  <span class="apostrophe">{{ n.giftname }}</span>
                </div>
              </div>
            </div>

            <!--按钮-->
            <img
              src="../../assets/turntable/tb(6).png"
              id="began_button"
              class="table-button absoluteItem centerX"
              v-if="able"
              @click="start_game"
            />
            <img
              src="../../assets/turntable/tb(8).png"
              class="table-button absoluteItem centerX clicked_button"
              v-else
            />
          </div>

          <!--幸运转盘-->

          <div class="table-center lucky-table absoluteItem">
            <img
              class="light"
              src="../../assets/turntable/lucky(5).png"
              v-show="lucky_bk"
            />
            <img
              class="light"
              src="../../assets/turntable/lucky(6).png"
              v-show="!lucky_bk"
            />

            <div class="f absoluteItem">
              <div
                class="item absoluteItem"
                :class="{ active: bingo === index }"
                v-for="(n, index) in luckylist"
                :key="index"
              >
                <img
                  src="../../assets/turntable/tb(11).png"
                  class="centerImg ac-img"
                  :class="{ hide_ac_img: bingo != index }"
                />
                <div class="big-shell absoluteItem centerImg">
                  <div class="img-shell relativeItem">
                    <img class="imgBlcok absoluteItem centerImg" :src="n.giftimage" />
                  </div>
                  <span class="apostrophe">{{ n.giftname }}</span>
                </div>
              </div>
            </div>

            <!--按钮-->
            <img
              src="../../assets/turntable/lucky(2).png"
              id="began_button"
              class="table-button absoluteItem centerX"
              v-if="able"
              @click="start_game"
            />
            <img
              src="../../assets/turntable/tb(8).png"
              class="table-button absoluteItem centerX clicked_button"
              v-else
            />
          </div>
        </div>

        <!--进度条-->
        <div class="lineShell">
          <p class="p1">
            幸运值：
            <span>{{ lucky_line.user_lucky_val }}</span>
            <i v-if="lucky_line.user_lucky_val < lucky_line.threeend"
              >（还差{{ lucky_line.cha }}幸运值，奖励升级）</i
            >
            <i v-else>（继续累积幸运值，奖励继续升级）</i>
          </p>
          <div class="outline relativeItem">
            <div class="line line0 flex-box relativeItem">
              <img
                class="imgBlock aimg"
                src="../../assets/turntable/tb(15).png"
                v-show="lucky_line.lucky_time <= 1"
              />
              <img
                class="imgBlock aimg"
                src="../../assets/turntable/tb(18).png"
                v-show="lucky_line.lucky_time <= 2 && lucky_line.lucky_time > 1"
              />
              <img
                class="imgBlock aimg"
                src="../../assets/turntable/tb(21).png"
                v-show="lucky_line.lucky_time <= 3 && lucky_line.lucky_time > 2"
              />

              <!--进度伸张部分-->
              <img
                class="imgBlock limg"
                :style="{ width: lucky_line.width }"
                src="../../assets/turntable/tb(17).png"
                v-show="lucky_line.lucky_time <= 1"
              />
              <img
                class="imgBlock limg"
                :style="{ width: lucky_line.width }"
                src="../../assets/turntable/tb(20).png"
                v-show="lucky_line.lucky_time <= 2 && lucky_line.lucky_time > 1"
              />
              <img
                class="imgBlock limg"
                :style="{ width: lucky_line.width }"
                src="../../assets/turntable/tb(23).png"
                v-show="lucky_line.lucky_time <= 3 && lucky_line.lucky_time > 2"
              />

              <!--右箭头-->
              <div class="aimg relativeItem">
                <img
                  class="imgBlock"
                  src="../../assets/turntable/tb(16).png"
                  v-show="lucky_line.lucky_time <= 1"
                />
                <img
                  class="imgBlock"
                  src="../../assets/turntable/tb(19).png"
                  v-show="lucky_line.lucky_time <= 2 && lucky_line.lucky_time > 1"
                />
                <img
                  class="imgBlock"
                  src="../../assets/turntable/tb(22).png"
                  v-show="lucky_line.lucky_time <= 3 && lucky_line.lucky_time > 2"
                />
                <!--粒子扩散-->
                <!-- <turnlizi class="absoluteItem centerY"></turnlizi> -->
              </div>
            </div>

            <!--星星和宝箱-->
            <div class="star star1 absoluteItem" :style="{ left: lucky_line.first_star }">
              <img
                class="imgBlock noevents-img"
                src="../../assets/turntable/tb(5).png"
                v-if="lucky_line.user_lucky_val >= lucky_line.firstend"
              />
              <img
                class="imgBlock noevents-img"
                src="../../assets/turntable/tb(4).png"
                v-else
              />
              <span
                class="s1"
                v-show="lucky_line.user_lucky_val >= lucky_line.firstend"
              ></span>
              <span
                class="s2"
                v-show="lucky_line.user_lucky_val >= lucky_line.firstend"
              ></span>
            </div>
            <div class="star star2 absoluteItem" :style="{ left: lucky_line.se_star }">
              <img
                class="imgBlock noevents-img"
                src="../../assets/turntable/tb(5).png"
                v-if="lucky_line.user_lucky_val >= lucky_line.twoend"
              />
              <img
                class="imgBlock noevents-img"
                src="../../assets/turntable/tb(4).png"
                v-else
              />
              <span
                class="s1"
                v-show="lucky_line.user_lucky_val >= lucky_line.twoend"
              ></span>
              <span
                class="s2"
                v-show="lucky_line.user_lucky_val >= lucky_line.twoend"
              ></span>
            </div>

            <div class="box absoluteItem" @click="show_lukey_gift">
              <img
                class="imgBlock absoluteItem centerImg boximg noevents-img"
                src="../../assets/turntable/tb(1).png"
              />
              <img
                class="imgBlock boxbk noevents-img"
                :class="{
                  show_box_bk: lucky_line.user_lucky_val >= lucky_line.threeend,
                }"
                src="../../assets/turntable/tb(3).png"
              />
            </div>
          </div>

          <p class="p2">
            <span v-show="lucky_line.giftstr != ''">幸运抽奖有大机率获得其中之一：</span>
            <span>{{ lucky_line.giftstr }}</span>
          </p>
        </div>

        <!--抽奖次数选择-->
        <div class="t-bottom flex-box">
          <div
            class="f-b relativeItem"
            :class="{ choosedFb: num === 1 }"
            @click="num = 1"
          >
            抽1次
            <img
              class="img1 absoluteItem centerY"
              src="../../assets/tablegame (11).png"
              v-if="num !== 1"
            />
            <img class="img2 absoluteItem" src="../../assets/tablegame.png" v-else />
          </div>
          <div
            class="r-b relativeItem"
            :class="{ choosedRb: num === 10 }"
            @click="num = 10"
          >
            抽10次
            <img
              class="img1 absoluteItem centerY"
              src="../../assets/tablegame (11).png"
              v-if="num !== 10"
            />
            <img class="img2 absoluteItem" src="../../assets/tablegame.png" v-else />
            <i>9折</i>
          </div>
          <div
            class="relativeItem"
            :class="{
              choosedLb: num === 2,
              'lucky-b': lucky_line.lucky_time != 0,
            }"
            @click="lucky_able"
          >
            幸运抽奖
            <img
              class="img1 absoluteItem centerY"
              src="../../assets/turntable/tb(10).png"
              v-if="num !== 2"
            />
            <img
              class="img2 absoluteItem"
              src="../../assets/turntable/tb(9).png"
              v-else
            />
          </div>
        </div>
        <p class="t-text" v-if="num != 2">
          点击开始消耗{{ num }}张抽奖券（{{ price.price }}钻石/张）
        </p>
        <p class="t-text" v-else>
          点击开始消耗所有幸运值和1张抽奖券（{{ price.price }}钻石/张）
        </p>

        <!--抽奖结果-->
        <div class="tc bold-tc" v-if="show_result">
          <div
            class="result-shell absoluteItem"
            :class="{ lucky_table_result: num === 2 || lucky_result }"
          >
            <img
              class="close-img absoluteItem"
              @click="show_result = false"
              src="../../assets/turntable/tb(25).png"
              v-if="num != 2 && !lucky_result"
            />
            <img
              class="close-img absoluteItem"
              @click="show_result = false"
              src="../../assets/turntable/lucky(1).png"
              v-else
            />

            <div class="good" v-if="gift_list.length > 0">
              <img
                class="title-img"
                src="../../assets/turntable/tb(24).png"
                v-if="num != 2 && !lucky_result"
              />
              <img class="title-img" src="../../assets/turntable/lucky(3).png" v-else />
              <gifts :list="gift_list" :pro="false" :witsh="'25%'" />
            </div>

            <div class="bad" v-else>
              <img src="../../assets/tablegame (7).png" />
              <p>很遗憾，没有抽中奖品T_T</p>
            </div>
          </div>
        </div>

        <!--全部幸运礼物奖品-->
        <div class="tc bold-tc" v-if="show_all_lucky">
          <div class="result-shell absoluteItem lucky_table_result">
            <img
              class="close-img absoluteItem"
              @click="show_all_lucky = false"
              src="../../assets/turntable/lucky(1).png"
            />
            <div class="good">
              <img class="title-img" src="../../assets/turntable/lucky(3).png" />
              <gifts :list="allLucklist" :pro="false" :witsh="'25%'" />
            </div>
          </div>
        </div>
      </div>

      <!--抽奖规则-->
      <div class="rule relativeItem" v-show="show === 2">
        <div class="r-top relativeItem title title-back">
          <img class="absoluteItem" src="../../assets/turntable.png" @click="show = 1" />
          抽奖规则
        </div>
        <div class="text">
          <p>
            <i>1</i
            >用户花费钻石购买抽奖券可参与幸运大转盘，赢取丰厚奖品，所中奖品存入背包。
          </p>
          <p>
            <i>2</i>
            中奖道具自获得起{{ price.turntable_val_day }}天内有效，过期则会失效。
          </p>
          <p>
            <i>3</i
            >通过转盘获取的道具不可兑换成钻石、现金及其他福利，平台严禁主播与用户私下交易，违规主播按照平台规则将严肃处理，请用户谨防上当受骗。
          </p>
          <p><i>4</i>中奖名单只展示2000钻石以上礼物的记录。</p>
          <p><i>5</i>中奖概率显示：</p>
        </div>
        <div class="good">
          <gifts :list="asclist" :pro="true" :witsh="'33%'" />
        </div>
      </div>

      <!--中奖记录-->
      <div class="records" v-show="show === 3">
        <div class="r-top relativeItem title title-back">
          <img class="absoluteItem" src="../../assets/turntable.png" @click="show = 1" />
          中奖记录
        </div>

        <div v-if="rec.length > 0">
          <ul class="list">
            <li class="overHidden" v-for="(n, index) in rec" :key="index">
              <span class="s1">{{ n.giftname }}</span>
              <span class="s2">{{ n.addtime }}</span>
            </li>
            <div></div>
          </ul>
          <div class="pre-nex">
            <span class="pre" :class="{ disable: page === 1 }" @touchstart="pre()"
              >上一页</span
            >
            <span
              class="nex"
              :class="{ disable: page === all_page && more }"
              @touchstart="next()"
              >下一页</span
            >
          </div>
        </div>

        <div class="no-records" v-else>
          <img src="../../assets/tablegame (5).png" />
          暂时没有中奖记录
        </div>
      </div>

      <!--排行榜-->
      <div class="paihang" v-show="show === 4">
        <div class="r-top relativeItem title title-back">
          <img class="absoluteItem" src="../../assets/turntable.png" @click="show = 1" />
          中奖名单
        </div>

        <!--标题-->
        <ul class="biaoti flex-box">
          <li class="l1">头像</li>
          <li class="l2">昵称</li>
          <li class="l3">朱贝号</li>
          <li class="l4">奖品</li>
        </ul>

        <!--榜单-->
        <ul class="paihang-list" v-if="p_list.length > 0">
          <li class="p-item flex-box" v-for="(n, index) in p_list" :key="index">
            <div class="head">
              <img class="imgBlock radius50 noevents-img" :src="n.avatar" />
            </div>
            <span class="s1 apostrophe">{{ n.nickname }}</span>
            <span class="s2">{{ n.usernumber }}</span>
            <div class="img-text">
              <img class="noevents-img gift-img" :src="n.giftimage" />
              {{ n.giftname }}
            </div>
          </li>

          <!--加载更多-->
          <!-- <p
            class="show_more flex-box"
            v-if="p_list_more"
            @click="get_more_phb"
          >
            <span>加载更多</span>
            <img
              class="noevents-img imgBlock"
              src="../../assets/more_arrow.png"
            />
          </p> -->
        </ul>
        <div class="no-records" v-else>
          <img src="../../assets/tablegame (5).png" />
          暂无数据
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="tc_main centerImg" v-show="show_tc_main">
      <p>请在app内部打开</p>
      <div class="btn_b flex-box">
        <div class="canle_btn" @click="show_tc_main = false">取消</div>
        <div class="confirm_btn" @click="closeWebPage">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import gifts from "./gifts";
// import turnlizi from "./turnlizi";

export default {
  name: "turntable",
  components: {
    gifts,
    // turnlizi,
  },
  data() {
    return {
      show_box_bk: false, //是否显示宝箱的发光背景
      line_width: 0,
      bk: true, //背景闪烁
      lucky_bk: true, //幸运转盘背景闪烁
      bingo: 0,
      times: 1, //旋转的圈数,
      gift_num: null, //中奖礼物的下标
      show_result: false, //是否显示抽奖结果
      show: 1, //1转盘 2规则 3记录 4排行榜
      rotateZ: "rotateZ(0deg)", //圆盘旋转角度
      transition: "all 4s ease-out",
      animation: "",
      text: [
        "用户花费钻石购买抽奖券可参与幸运大转盘，赢取丰厚奖品，所中奖品存入背包。",
        "中奖道具自获得起30天内有效，过期则会失效。",
        "通过转盘获取的道具不可兑换成钻石、现金及其他福利，平台严禁主播与用户私下交易，违规主播按照平台规则将严肃处理，请用户谨防上当受骗。",
        "中奖名单只展示2000钻石以上礼物的记录",
        "中奖概率显示：",
      ], //抽奖规则
      num: 1, //抽奖次数
      gift_list: [], //中奖列表
      userinfo: {}, //用户信息
      asclist: [], //规则循环
      price: {}, //价格
      list: {}, //基本数据
      luckylist: [], //当前用户可抽的幸运礼物列表
      allLucklist: [], //后台全部幸运礼物
      show_all_lucky: false, //显示全部幸运礼物
      lucky_result: false, //是否显示幸运礼物的结果
      able: true, //是否可以抽奖
      records: [], //记录列表
      rec: [], //当前显示的记录
      page: 1, //记录页码
      pagesize: 10, //记录每页数据量
      all_page: 0, //所有页面数量
      more: true, //是否可以点击下一页
      get_news_list: [], //中奖公告
      bk_change: null, //背景切换的计时器
      lucky_line: {
        user_lucky_val: 0,
      }, //进度条信息
      p_list: [], //排行榜列表
      p_phb_page: 1,
      p_list_more: true, //排行榜列表是否有更多的标识
      closeSta: 0, //判断转盘是否被关闭
      isWebOpen: true, // 判断是不是网页打开的
      show_tc_main: true,
    };
  },
  methods: {
    /**获取礼物数据 */
    get_data() {
      let data = {
        type: this.see == 2 ? 1 : 0,
      };
      let _this = this;
      this.$jsonp(this.$apis("Turntablelist", "app"), data, (res) => {
        _this.closeSta = res.data.data.result.closeSta;
        _this.asclist = res.data.data.result.list.asclist;
        _this.list = res.data.data.result.list.list;
        _this.luckylist = res.data.data.result.list.lucklist;
        _this.allLucklist = res.data.data.result.list.alllucklist;
        _this.price = res.data.data.result.list.pricelist;
        _this.userinfo = res.data.data.result.userinfo;
      });
    },

    /**获取中将记录 */
    get_records() {
      let data = {
        page: this.page,
        pagesize: this.pagesize,
      };
      let _this = this;
      this.$jsonp(this.$apis("tableMylucklog", "app"), data, (res) => {
        _this.all_page = res.data.data.result.allpage;
        let ls = res.data.data.result.list;
        if (ls.length > 0) {
          _this.rec = ls;
          _this.records.push(ls);
          _this.more = true;
        }
      });
    },
    /**上一页 */
    pre() {
      if (this.page > 1) {
        this.page--;
        this.rec = this.records[this.page - 1];
      }
    },
    /**下一页 */
    next() {
      if (this.page < this.all_page && this.more) {
        this.page++;
        if (this.records[this.page - 1] != undefined) {
          this.rec = this.records[this.page - 1];
        } else {
          this.more = false;
          this.get_records();
        }
      }
    },

    /**获取排行榜 */
    get_phb() {
      let data = {
        page: this.p_phb_page,
        pagesize: 50,
      };
      let _this = this;
      this.$jsonp(this.$apis("turn_table_phb", "app"), data, (res) => {
        let ls = res.data.data.data;
        if (ls.length > 0) {
          _this.p_list = _this.p_list.concat(ls);
        } else {
          _this.p_list_more = false;
        }
      });
    },

    /**点击加载更多排行榜内容 */
    get_more_phb() {
      this.p_phb_page++;
      this.get_phb();
    },

    /**获取中奖公告 */
    get_news() {
      let _this = this;
      this.$jsonp(this.$apis("Logrunlist", "app"), {}, (res) => {
        let ls = res.data.data.result.list;
        let div_shell = document.getElementsByClassName("quee-shell")[0],
          div = document.getElementsByClassName("mar-items")[0];
        div_shell.style.width = ls.length * 16 + ls.length * 0.6 + "rem";
        div.style.width = ls.length * 18 + ls.length * 0.6 + "rem";
        setTimeout(() => {
          _this.get_news_list = res.data.data.result.list;
          _this.animation = "marqueeLeft " + ls.length * 5 + "s linear infinite";
        }, 1000);
      });
    },

    /**点击大宝箱展开幸运礼物列表 */
    show_lukey_gift() {
      this.show_all_lucky = true;
    },

    /**判断是否可进行幸运抽奖 */
    lucky_able() {
      if (this.lucky_line.lucky_time >= 1) {
        this.num = 2;
      } else {
        this.$tool.tip("幸运值不够");
      }
    },

    /**开始并随机改变转盘角度 */
    start_game() {
      //判断转盘是否开启中
      if (this.closeSta == 1) {
        _this.$tool.tip("转盘暂时被封禁", "70%");
        return false;
      }

      //先判断用户余额是否充足
      if (this.num === 1) {
        if (this.userinfo.balance * 1 < this.price.price * 1) {
          //前往充值
          this.$tool.recharge();
          return;
        }
      } else if (this.num === 10) {
        if (this.userinfo.balance * 1 < this.price.discountprice * 1) {
          //前往充值
          this.$tool.recharge();
          return;
        }
      } else {
        //幸运抽奖
        if (this.lucky_line.lucky_time <= 0) {
          //前往充值
          this.$tool.tip("幸运值不够");
          return;
        }
        if (this.userinfo.balance * 1 < this.price.price * 1) {
          //前往充值
          this.$tool.recharge();
          return;
        }
      }

      //防止用户重复点击
      if (this.able) {
        this.able = false;
      } else {
        return;
      }

      let data = {};
      if (this.num == 2) {
        //走幸运抽奖方式
        data.type = 1;
        data.num = 1;
      } else {
        //次数抽奖
        data.num = this.num;
      }
      //开始旋转
      let pre_turn = setInterval(() => {
        if (this.bingo >= 11) {
          this.bingo = 0;
        } else {
          this.bingo++;
        }
      }, 100);

      // return false;
      //播放音效
      // this.control_audio();
      let _this = this;
      this.$jsonp(this.$apis("tableLuckdraw", "app"), data, (res) => {
        if (res.data.data.result.status === 200) {
          _this.gift_list = res.data.data.result.list;
          _this.userinfo = res.data.data.result.userinfo;
          //让app刷新礼物
          setTimeout(() => {
            if (_this.$cookie.getC("platform") == "app") {
              _this.$appAc.toRefreshGift();
            }
          }, 300);
          clearInterval(pre_turn);
          //设置转盘停止的角度
          if (_this.num != 2) {
            //普通转盘
            for (let i = 0; i < _this.list.length; i++) {
              if (_this.list[i].giftid === _this.gift_list[0].giftid) {
                _this.gift_num = i;
                _this.turn_began();
              }
            }
          } else {
            //幸运转盘
            for (let i = 0; i < _this.luckylist.length; i++) {
              if (_this.luckylist[i].giftid === _this.gift_list[0].giftid) {
                _this.gift_num = i;
                _this.turn_began();
              }
            }
          }
        } else {
          _this.$tool.tip(res.data.data.result.msg, "70%");
          _this.able = true;
        }
      });
    },

    /**
     * 中奖旋转方法
     * 在一定时间内更换bingo的值
     */
    turn_began() {
      let _this = this;
      let n = 0; //旋转的圈数
      let more_num = null; //转3圈之后随机前进的格子数
      let begen = setInterval(() => {
        //开始旋转
        if (_this.bingo >= 11) {
          _this.bingo = 0;
          n++;
        } else {
          _this.bingo++;
        }
        //如果旋转圈数达到了1圈就随机生成剩余前进的格子数
        if (_this.gift_num != null && n === 1) {
          more_num = Math.ceil(Math.random() * 11);
        }

        if (more_num != null && _this.bingo === more_num) {
          //开始最后的旋转直到抵达中奖目标
          clearInterval(begen);
          _this.last_turn();
        }
      }, 100);
    },
    last_turn() {
      let _this = this;
      let end = setInterval(() => {
        //开始旋转
        if (_this.bingo >= 11) {
          _this.bingo = 0;
        } else {
          _this.bingo++;
        }
        //如果旋转圈数达到了设定的量就停止旋转
        if (_this.gift_num === _this.bingo) {
          clearInterval(end);
          // _this.control_audio();
          //开始最后的旋转直到抵达中奖目标
          setTimeout(() => {
            _this.able = true;
            _this.show_all_lucky = false;
            _this.show_result = true;
            _this.get_data();
            _this.get_lucky_line();
          }, 500);
        }
      }, 500);
    },

    //背景闪烁计时器
    change_bk() {
      let _this = this;
      _this.bk_change = setInterval(() => {
        if (_this.num === 2) {
          _this.lucky_bk = !_this.lucky_bk;
        } else {
          _this.bk = !_this.bk;
        }
      }, 1000);
    },

    /**获取幸运值的进度条 */
    get_lucky_line() {
      let _this = this;
      this.$jsonp(this.$apis("lucky_line"), {}, (res) => {
        _this.lucky_line = res.data.data.result.list;
        //计算进度条
        _this.lucky_line.width = parseFloat(_this.lucky_line.bilie) * 100 - 4;
        if (_this.lucky_line.width <= 0) {
          _this.lucky_line.width = "0%";
        } else {
          _this.lucky_line.width += "%";
        }

        //设置幸运抽奖的次数
        _this.lucky_line.lucky_time = 0;
        if (_this.lucky_line.user_lucky_val >= _this.lucky_line.threeend) {
          _this.lucky_line.lucky_time = 3;
        } else if (
          _this.lucky_line.user_lucky_val >= _this.lucky_line.twoend &&
          _this.lucky_line.user_lucky_val < _this.lucky_line.threeend
        ) {
          _this.lucky_line.lucky_time = 2;
        } else if (
          _this.lucky_line.user_lucky_val >= _this.lucky_line.firstend &&
          _this.lucky_line.user_lucky_val < _this.lucky_line.twoend
        ) {
          _this.lucky_line.lucky_time = 1;
        }

        /**计算星星的位置 */
        _this.lucky_line.first_star =
          ((_this.lucky_line.firstend / _this.lucky_line.threeend) * 100).toFixed(2) +
          "%";
        _this.lucky_line.se_star =
          ((_this.lucky_line.twoend / _this.lucky_line.threeend) * 100).toFixed(2) + "%";
      });
    },

    /**关闭webview */
    closeweb() {
      this.$appAc.closeWeb();
    },

    /**控制效果音效的播放 */
    control_audio() {
      let audio = document.getElementById("audio");
      if (audio.paused) {
        // 如果是暂停状态, 让其播放, 反之暂停
        audio.currentTime = 0;
        audio.play();
      } else {
        audio.pause();
      }
      audio = null;
    },

    /**控制翻转时两个转盘的zindex */
    //红色上
    h_1_l_2() {
      document.querySelector(".com-table").style.visibility = "hidden";
      document.querySelector(".lucky-table").style.visibility = "visible";
    },
    //黄色上
    h_2_l_1() {
      document.querySelector(".com-table").style.visibility = "visible";
      document.querySelector(".lucky-table").style.visibility = "hidden";
    },

    // 判断是不是浏览器打开  是就弹窗关闭 platform == 'app'就打开
    webOpenFun() {
      let nowHost = window.location.host;
      if (this.$tool.platform != "app" && nowHost != "localhost:8080") {
        this.isWebOpen = false;
      }
    },
    closeWebPage() {
      window.opener = null;
      window.open("", "_self");
      window.close();
    },
  },
  mounted: function () {
    this.$tool.setTitle("抽奖大转盘");
    this.get_data();
    this.get_news();
    this.change_bk();
    this.get_lucky_line();
    document.getElementsByTagName("html")[0].style.background = "none";
    //延迟显示宝箱的发光背景
    this.webOpenFun(); //判断是不是浏览器打开  是就弹窗关闭 platform == 'app'就打开
  },
  watch: {
    show(val) {
      if (val === 3) {
        this.records = [];
        this.rec = [];
        this.page = 1;
        this.get_records();
      }
      if (val === 4 && this.p_phb_page === 1) {
        this.get_phb();
      }
    },
    //每次关闭结果弹窗都将lucky_result设置为false
    show_result(val) {
      if (!val) {
        if (this.num == 2) {
          this.num = 1;
        }
        this.lucky_result = false;
      }
    },
    //控制转盘翻转时zindex的设置
    num(val) {
      let _this = this;
      if (val === 2) {
        //显示红色转盘
        setTimeout(() => {
          _this.h_1_l_2();
        }, 200);
      } else {
        //显示黄色转盘
        setTimeout(() => {
          _this.h_2_l_1();
        }, 200);
      }
    },
  },
};
</script>

<style scoped lang="scss">
$line: 8.5%;
$far_line: 29.5%;

.main_tc {
  position: relative;
  background: none;
  height: 100vh;
}

#turntable {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  // height: 60%;
  padding: 0.95rem;
  background: url("../../assets/tablegame (12).png");
  background-size: 100% 100%;
  // overflow-y: scroll;
}

.title {
  padding-bottom: 0.6rem;
  border-bottom: 1px solid rgba($color: #fff, $alpha: 0.05);
}

/*转盘区域*/
.table {
  width: 100%;

  > div {
    align-items: center;
  }

  .ph-button {
    width: 10%;
  }

  .marquee {
    width: 40%;
    height: 1.5rem;
    font-size: 13px;
    color: rgba($color: #fff, $alpha: 0.5);
    overflow: hidden;
    margin-left: 5px;
  }
  .mar-items {
    position: relative;
    height: 1.5rem;
  }

  .marquee-item {
    width: 18rem;
    height: 1.5rem;
    line-height: 1.5rem;
    margin-right: 0.6rem;
  }
  .name {
    color: #fff;
  }
  .gift {
    color: #ffd400;
  }
  .top-button {
    display: inline-block;
    font-size: 12px;
    color: #fff;
    border-radius: 0.75rem;
    width: 4.375rem;
    height: 1.5rem;
    line-height: 1.5rem;
    text-align: center;
    background: rgba($color: #fff, $alpha: 0.3);
    margin-left: 5%;
  }

  .out-light {
    position: absolute;
    width: 109%;
    left: 50%;
    top: 8%;
    z-index: 0;
    transform: translateX(-50%);
  }

  .tableShell {
    margin: 0.75rem auto 1.1rem auto;
  }
  .table-center {
    width: 92%;
    margin: 0 auto;
    transition: transform 0.6s;
  }
  .com-table {
    visibility: visible;
  }
  .lucky-table {
    visibility: hidden;
    width: 92%;
    left: 50%;
    top: 50%;
    transform-origin: left top;
    transform: rotateY(180deg) translateX(-50%) translateY(-50%);
  }
  .tableShell180 {
    .com-table {
      transform: rotateY(-180deg);
    }
    .lucky-table {
      transform: rotateY(0deg) translateX(-50%) translateY(-50%);
    }
  }
  .light {
    display: block;
  }
  .f {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 3% 5%;
  }
  .item {
    width: 19.7%;
    height: 18%;
    background: url("../../assets/turntable/tb(7).png") no-repeat left top;
    background-size: 100% 100%;
    font-size: 9px;
    color: #a65300;
    text-align: center;

    .big-shell {
      width: 100%;
      height: 100%;
    }
    .ac-img {
      width: 122%;
      height: 130%;
    }
    .hide_ac_img {
      transition: all 0.6s;
      opacity: 0;
    }
    .img-shell {
      width: 40%;
      height: 64%;
      margin: 0 auto;
      margin-top: 2px;
    }
    img {
      width: 100%;
    }
    span {
      display: inline-block;
      max-width: 100%;
    }
  }
  .table-center {
    .item:nth-child(1),
    .item:nth-child(2),
    .item:nth-child(3),
    .item:nth-child(4) {
      top: 10.5%;
    }
    .item:nth-child(7),
    .item:nth-child(8),
    .item:nth-child(9),
    .item:nth-child(10) {
      bottom: 10.5%;
    }
    .item:nth-child(1) {
      left: $line;
    }
    .item:nth-child(2) {
      left: $far_line;
    }
    .item:nth-child(3) {
      right: $far_line;
    }
    .item:nth-child(4) {
      right: $line;
    }
    .item:nth-child(5) {
      right: $line;
      top: 30.8%;
    }
    .item:nth-child(6) {
      right: $line;
      bottom: 31%;
    }
    .item:nth-child(7) {
      right: $line;
    }
    .item:nth-child(8) {
      right: $far_line;
    }
    .item:nth-child(9) {
      left: $far_line;
    }
    .item:nth-child(10) {
      left: $line;
    }
    .item:nth-child(11) {
      left: $line;
      bottom: 31%;
    }
    .item:nth-child(12) {
      top: 30.8%;
      left: $line;
    }
  }

  .lucky-table {
    .item {
      color: #8d031b;
    }
    .item:nth-child(1),
    .item:nth-child(2),
    .item:nth-child(3),
    .item:nth-child(4) {
      top: 10.5%;
    }
    .item:nth-child(7),
    .item:nth-child(8),
    .item:nth-child(9),
    .item:nth-child(10) {
      bottom: 10.5%;
    }
    .item:nth-child(1) {
      left: $line;
    }
    .item:nth-child(2) {
      left: $far_line;
    }
    .item:nth-child(3) {
      right: $far_line;
    }
    .item:nth-child(4) {
      right: $line;
    }
    .item:nth-child(5) {
      right: $line;
      top: 30.8%;
    }
    .item:nth-child(6) {
      right: $line;
      bottom: 31%;
    }
    .item:nth-child(7) {
      right: $line;
    }
    .item:nth-child(8) {
      right: $far_line;
    }
    .item:nth-child(9) {
      left: $far_line;
    }
    .item:nth-child(10) {
      left: $line;
    }
    .item:nth-child(11) {
      left: $line;
      bottom: 31%;
    }
    .item:nth-child(12) {
      top: 30.8%;
      left: $line;
    }
  }

  .active {
    .ac-img {
      opacity: 1;
    }
  }

  .table-button {
    width: 38%;
    top: 53%;
    // z-index: 1;
  }
  .lucky-table .table-button {
    z-index: 3;
  }
  .clicked_button {
    transform: translateX(-50%) scale(0.95);
  }

  .tClicked {
    transform: scale(0.95);
  }

  /**抽奖次数 */
  .t-bottom {
    color: #fff;
    justify-content: space-between;
    padding: 0;
    div {
      width: 31%;
      height: 2.3rem;
      line-height: 2.3rem;
      background: rgba($color: #fff, $alpha: 0.15);
      border-radius: 2.5rem;
      font-size: 85%;
      text-align: right;
      padding-right: 5%;
    }
    .f-b {
      padding-right: 8%;
    }
    .r-b {
      padding-right: 7%;
    }
    .lucky-b {
      animation: boxS 1s ease infinite;
    }
    .choosedFb {
      background: -webkit-linear-gradient(left, #ff616e, #ff4857);
      box-shadow: 0 0 10px rgba(255, 95, 109, 0.7);
    }
    .choosedRb {
      background: -webkit-linear-gradient(left, #fe83e8, #921aff);
      box-shadow: 0 0 3px rgba(252, 129, 233, 0.7);
    }
    .choosedLb {
      background: -webkit-linear-gradient(left, #ffc700, #f97e01);
      box-shadow: 0 0 3px rgba(252, 129, 233, 0.7);
    }
    img {
      right: 71%;
    }
    .img1 {
      width: 22%;
    }
    .img2 {
      width: 38%;
      bottom: 1%;
    }

    i {
      font-style: normal;
      background: #ff4757;
      display: block;
      position: absolute;
      text-align: center;
      width: 2rem;
      height: 0.875rem;
      line-height: 0.875rem;
      font-size: 10px;
      color: white;
      top: -0.3rem;
      right: -0.4rem;
      border-radius: 3rem;
    }
  }
  .t-text {
    text-align: center;
    margin-top: 0.8rem;
    color: #999;
    font-size: 14px;
  }

  .result-shell {
    top: 50%;
    width: 85%;
    min-height: 10.375rem;
    border-radius: 0.75rem;
    border: 1px solid #e5b149;
    left: 50%;
    background: rgba($color: #000000, $alpha: 0.85);
    box-shadow: 0 0 10px #e5b149 inset;
    transform: translateX(-50%) translateY(-50%);
    .close-img {
      width: 1rem;
      height: 1rem;
      right: 4%;
      top: 5%;
    }
    .title-img {
      display: block;
      width: 64%;
      margin: 1rem auto 1rem auto;
    }

    .bad {
      margin-top: 3rem;
      text-align: center;
      img {
        width: 2.8rem;
      }
      p {
        font-size: 13px;
        color: #ffd400;
      }
    }
  }
  .lucky_table_result {
    border: 1px solid #b3334d;
    box-shadow: 0 0 10px #b3334d inset;
  }
}

.good {
  width: 80%;
  margin: 0 auto;
}

/**幸运值进度条 */
.lineShell {
  margin-top: 8px;
  padding: 0 4%;
  .aimg {
    width: 2%;
    height: 100%;
  }
  p {
    padding: 0 10px;
  }
  .p1 {
    font-size: 11px;
    color: white;
    margin-bottom: 6px;
    span {
      font-size: 12px;
      color: #ffaa00;
    }
    i {
      font-style: normal;
      font-size: 10px;
      color: #858a8c;
    }
  }

  .p2 {
    width: 90%;
    min-height: 30px;
    font-size: 10px;
    color: #858a8c;
    text-align: justify;
    margin-top: 7px;
    margin-bottom: 6px;
    span {
      color: #8c6301;
    }
  }

  .outline {
    width: 100%;
    background: url("../../assets/turntable/tb(14).png") no-repeat left center;
    background-size: 100% 100%;
    height: 16px;
    padding: 1px;
    .line {
      height: 100%;
      img {
        height: 100%;
      }
    }
    .limg {
      transition: all 0.6s;
    }
  }

  /**星星和宝箱 */
  .star {
    width: 7%;
    z-index: 1;
  }
  .star span {
    position: absolute;
    opacity: 1;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    content: "";
    width: 80%;
    height: 80%;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.4);
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    z-index: -1;
  }
  .s1 {
    animation: turntableCircle 4s ease-out infinite;
    -webkit-animation: turntableCircle 4s ease-out infinite;
  }
  .s2 {
    animation: turntableCircle 4s 0.3s ease-out infinite;
  }
  // .s3 {
  //   animation: turntableCircle 4s .6s ease-out infinite;
  // }

  .star1 {
    top: 50%;
    left: 30%;
    transform: translateY(-50%) translateX(-50%);
  }
  .star2 {
    top: 50%;
    left: 60%;
    transform: translateY(-50%) translateX(-50%);
  }
  .box {
    width: 31%;
    right: -8%;
    top: -250%;
    z-index: 2;
    transform: perspective(1000);
    -webkit-transform: perspective(1000);
  }
  .boximg {
    width: 53%;
  }
  .boxbk {
    opacity: 0;
    position: relative;
    z-index: -1;
    transform-origin: center;
    -webkit-transform-origin: center;
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    animation: clist_time_r 3s linear infinite;
    -webkit-animation: clist_time_r 3s linear infinite;
  }
  .show_box_bk {
    opacity: 1 !important;
  }
}

/*抽奖规则*/
.title-back {
  font-size: 18px;
  color: #fff;
  text-align: center;
  padding-left: 30px;

  img {
    width: 1.25rem;
    left: 0;
    top: 0.1rem;
  }
}
.rule {
  text-align: center;

  .text {
    width: 85%;
    margin: 0.85rem auto 0 auto;
    font-size: 13px;
    color: white;
    text-align: justify;
    line-height: 1.375rem;
    margin-bottom: 0.8rem;
  }
  i {
    display: inline-block;
    font-style: normal;
    border-radius: 50%;
    background: #feca57;
    width: 0.875rem;
    height: 0.875rem;
    text-align: center;
    line-height: 0.875rem;
  }
}

/*中奖记录*/
.list {
  margin: 0.7rem 0 0.85rem 0;
  padding: 0 1rem;
  font-size: 12px;

  li {
    margin-bottom: 0.7rem;
  }
  .s1 {
    color: #ffd400;
  }
  .s2 {
    color: white;
    float: right;
  }
}

.no-records {
  text-align: center;
  padding-top: 5rem;
  padding-bottom: 2rem;
  font-size: 14px;
  color: #666;

  img {
    display: block;
    margin: 0 auto;
    margin-bottom: 5px;
    width: 2.125rem;
  }
}

.pre-nex {
  position: relative;
  text-align: center;
  color: #fff;
  ::after {
    position: absolute;
    content: "";
    height: 80%;
    width: 1px;
    background: #fff;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%) scaleX(0.5);
  }
  span {
    font-size: 13px;
  }
}
.pre {
  display: inline-block;
  margin-right: 1.5rem;
}
.disable {
  color: #666;
}

/**排行榜 */
.biaoti {
  /**标题样式 */
  color: #766f6d;
  font-size: 13px;
  padding: 15px 0;
  justify-content: space-between;
  text-align: center;
  .l1,
  .l2 {
    width: 20%;
  }
  .l3 {
    width: 25%;
  }
  .l4 {
    width: 35%;
  }
}

/**列表样式 */
.paihang-list {
  height: 59vh;
  padding-bottom: 10px;
  overflow-y: scroll;
}
.p-item {
  align-items: center;
  padding: 10px 0;
}
.head,
.s1 {
  width: 20%;
  text-align: center;
  color: #ffd400;
  font-size: 13px;
  img {
    width: 50%;
    margin: 0 auto;
  }
}
.s2 {
  width: 25%;
  text-align: center;
  color: white;
  font-size: 12px;
}
.img-text {
  width: 35%;
  font-size: 12px;
  color: #999;
  text-align: center;
}
.img-text * {
  vertical-align: middle;
}
.gift-img {
  max-width: 37%;
  margin-right: 2px;
}
.show_more {
  font-size: 12px;
  color: white;
  justify-content: center;
  align-items: center;
  * {
    vertical-align: middle;
  }
  img {
    width: 10px;
    height: 10px;
    margin-left: 4px;
  }
}

/*深色弹窗*/
.bold-tc {
  background: rgba($color: #000000, $alpha: 0.7);
}

// web端的提示
.tc_main {
  width: 80%;
  background-color: #f5f5f5;
  border-radius: 12px;
}
.tc_main p {
  text-align: center;
  padding: 18px;
  color: #666;
}
.btn_b {
  width: 100%;
  padding: 18px 12px;
  justify-content: space-around;
}
.canle_btn,
.confirm_btn {
  font-size: 14px;
  padding: 6px 20px;
  border-radius: 18px;
}
.canle_btn {
  color: #70421e;
  background: linear-gradient(to right, #f7deba, #e3bd93);
  background: -webkit-linear-gradient(left, #f7deba, #e3bd93);
}
.confirm_btn {
  color: #fff;
  background: linear-gradient(to right, #ff694c, #ff3447);
  background: -webkit-linear-gradient(left, #ff694c, #ff3447);
}
</style>
